import {readable} from 'svelte/store';
import {marcinOrlowski} from "./pages/marcin_orlowski";
import {homepage} from "./other/homepage";
import {team} from "./other/team";
import {jagodaGajewska} from "./pages/jagoda_gajewska";
import {joannaRoch} from "./pages/joanna_roch";
import {gabrielaJaniszewska} from "./pages/gabreial-janiszewska";
import {magdalenaSmorowska} from "./pages/magdalena-smorowska";
import {magdalenaKruczynska} from "./pages/magdalena-kruczynska";
import {annaJaniszewska} from "./pages/anna-janiszewska";
import {ecaterinaCocetcova} from "./pages/ecaterina-cocetcova";
import {martaAndracka} from "./pages/marta-andracka";
import {malgorzataOpara} from "./pages/malgorzata-opara";
import {dominikaChylinska} from "./pages/dominika-chylinska";
import {krzysztofRosa} from "./pages/krzysztof-rosa";
import {pawelRadziejewski} from "./pages/pawel-radziejewski";
import {services} from "./other/services";
import {dominikaKalabinska} from "./pages/dominika-kalabinska";
import {miroslawaJakubowska} from "./pages/miroslawa-jakubowska";
import {cooperation} from "./other/cooperation";
import {jobs} from "./other/jobs";
import {pricing} from "./other/pricing";
import {contact} from "./other/contact";
import {malgorzataSolska} from "./pages/malgorzata-solska";
import {agnieszkaGuminska} from "./pages/agnieszka-guminska";
import {martaMalecka} from "./pages/marta-malecka";
import {urszulaSzulc} from "./pages/urszula-szulc";
import {visit} from "./other/visit";
import {agataMccarthy} from "./pages/agata-mccarthy";
import {magdalenaDabrowska} from "./pages/magdalena-dabrowska";
import {dymitrLeszko} from "./pages/dymitr-leszko";
import {katarzynaLietz} from "./pages/katarzyna-lietz";
import {nataliaSarnowska} from "./pages/natalia-sarnowska";
import {magdalenaFajkowska} from "./pages/magdalena-fajkowska";
import {joannaWisniewska} from "./pages/joanna-wisniewska";
import {patrykCentek} from "./pages/patryk-centek";
import {aleksanderJachowski} from "./pages/aleksander-jachowski";
import {aleksandraTrzcinska} from "./pages/aleksandra-trzcinska";
import {elzbietaKuleszko} from "./pages/elzbieta-kuleszko";
import {annaChwialkowska} from "./pages/anna-chwialkowska";
import {agataStark} from "./pages/agata-stark";
import {sylwiaTrafna} from "./pages/sylwia-trafna";
import {alinaMatlakiewicz} from "./pages/alina-matlakiewicz";
import {nataliaJarek} from "./pages/natalia-jarek";
import {tomaszBett} from "./pages/tomasz-bett";
import {dagmaraRacaPiekarz} from "./pages/dagmara-raca-piekarz";
import {kingaIwanska} from "./pages/kinga-iwanska";
// import {ewaKotecka} from "./pages/ewa-kotecka";
import {annaWroblewskaCzerniak} from "./pages/anna-wroblewska-czerniak";
import {dorotaKuffel} from "./pages/dorota-kuffel";
import {karolinaKasprzak} from "./pages/karolina-kasprzak";
import {magdalenaWaszak} from "./pages/magdalena-waszak";
import {annaLobocka} from "./pages/anna-lobocka";
import {janinaMalkowska} from "./pages/janina-malkowska";
import {mikolajKlosowski} from "./pages/mikolaj-klosowski";
import {joannaMaciejewska} from "./pages/joanna-maciejewska";
import {pawelMurawski} from "./pages/pawel-murawski";
// import {magdalenaSzulczewska} from "./pages/magdalena-szulczewska";
import {katarzynaWolska} from "./pages/katarzyna-wolska";
import {anetaStawiszynskaBiarda} from "./pages/aneta-stawiszynska-biarda";
import {blog} from "./other/blog/blog";
import {theImportanceOfSleepForMentalHealth} from "./other/blog/theImportanceOfSleepForMentalHealth";
import {psychoTermsExplained} from "./other/blog/psychoTermsExplained";
import {patrycjaSawicka} from "./pages/patrycja-sawicka";
import {psychodynamicPsychotherapy} from "./other/blog/psychodynamicPsychotherapy";
import {malgorzataRzymyszkiewicz} from "./pages/malgorzata-rzymyszkiewicz";
import {agnieszkaDajnowska} from "./pages/agnieszka-dajnowska";
import {magdaBazan} from "./pages/magda-bazan";
import {joannaKrzyzanowska} from "./pages/joanna-krzyzanowska";
import {regulations} from "./other/regulations";
// import {jakubGrodecki} from "./pages/jakub-grodecki";
import {zofiaKurowska} from "./pages/zofia-kurowska";
// import {martynaMarzec} from "./pages/martyna-marzec";
import {malgorzataStarczewska} from "./pages/malgorzata-starczewska";
import {karolinaWaligora} from "./pages/karolina-waligora";
import {agnieszkaFarbiszewska} from "./pages/agnieszka-farbiszewska";
import {mateuszMaternia} from "./pages/mateusz-maternia";
import {mikolajRak} from "./pages/mikolaj-rak";
import {kingaMrowka} from "./pages/kinga-mrowka";
import {monikaKruszyna} from "./pages/monika-kruszyna";
import {agnieszkaGorna} from "./pages/agnieszka-gorna";

export const pages = readable({}, function start(set) {
    set({
        'other': {
            'homepage': homepage,
            'services': services,
            'cooperation': cooperation,
            'jobs': jobs,
            'visit': visit,
            'contact': contact,
            'pricing': pricing,
            'regulations': regulations,
            'blog': {
                'overall': blog,
                'articles': {
                    'theImportanceOfSleepForMentalHealth': theImportanceOfSleepForMentalHealth,
                    'psychoTermsExplained': psychoTermsExplained,
                    'psychodynamicPsychotherapy': psychodynamicPsychotherapy
                }
            },
            'team': {
                'overall': team,
                'psychoterapy': {
                    'marcinOrlowski': marcinOrlowski,
                    'jagodaGajewska': jagodaGajewska,
                    'joannaRoch': joannaRoch,
                    'gabrielaJaniszewska': gabrielaJaniszewska,
                    'magdalenaSmorowska': magdalenaSmorowska,
                    'magdalenaKruczynska': magdalenaKruczynska,
                    'dominikaKalabinska': dominikaKalabinska,
                    'miroslawaJakubowska': miroslawaJakubowska,
                    'malgorzataSolska': malgorzataSolska,
                    'agnieszkaGuminska': agnieszkaGuminska,
                    'magdalenaDabrowska': magdalenaDabrowska,
                    'dymitrLeszko': dymitrLeszko,
                    'katarzynaLietz': katarzynaLietz,
                    'nataliaSarnowska': nataliaSarnowska,
                    'magdalenaFajkowska': magdalenaFajkowska,
                    'joannaWisniewska': joannaWisniewska,
                    'aleksanderJachowski': aleksanderJachowski,
                    'aleksandraTrzcinska': aleksandraTrzcinska,
                    'elzbietaKuleszko': elzbietaKuleszko,
                    'annaChwialkowska': annaChwialkowska,
                    'agataStark': agataStark,
                    'alinaMatlakiewicz': alinaMatlakiewicz,
                    'nataliaJarek': nataliaJarek,
                    'kingaIwanska': kingaIwanska,
                    'kingaMrowka': kingaMrowka,
                    // 'ewaKotecka': ewaKotecka,
                    'annaWroblewskaCzerniak': annaWroblewskaCzerniak,
                    'dorotaKuffel': dorotaKuffel,
                    'karolinaKasprzak': karolinaKasprzak,
                    'annaLobocka': annaLobocka,
                    'joannaMaciejewska': joannaMaciejewska,
                    'pawelMurawski': pawelMurawski,
                    // 'magdalenaSzulczewska': magdalenaSzulczewska,
                    'malgorzataRzymyszkiewicz': malgorzataRzymyszkiewicz,
                    'joannaKrzyzanowska': joannaKrzyzanowska,
                    'sylwiaTrafna': sylwiaTrafna,
                    // 'jakubGrodecki': jakubGrodecki,
                    // 'martynaMarzec': martynaMarzec,
                    'karolinaWaligora': karolinaWaligora,
                    'agnieszkaFarbiszewska': agnieszkaFarbiszewska,
                    'monikaKruszyna': monikaKruszyna,
                    'agnieszkaGorna': agnieszkaGorna,
                },
                'psychiatry': {
                    'annaJaniszewska': annaJaniszewska,
                    'ecaterinaCocetcova': ecaterinaCocetcova,
                    'dagmaraRacaPiekarz': dagmaraRacaPiekarz,
                    'agataMccarthy': agataMccarthy,
                    'martaAndracka': martaAndracka,
                    'malgorzataOpara': malgorzataOpara,
                    'dominikaChylinska': dominikaChylinska,
                    'krzysztofRosa': krzysztofRosa,
                    'pawelRadziejewski': pawelRadziejewski,
                    'urszulaSzulc': urszulaSzulc,
                    'patrykCentek': patrykCentek,
                    'tomaszBett': tomaszBett,
                    'janinaMalkowska': janinaMalkowska,
                    'mikolajKlosowski': mikolajKlosowski,
                    'mikolajRak': mikolajRak,
                    'katarzynaWolska': katarzynaWolska,
                    'patrycjaSawicka': patrycjaSawicka,
                    'magdaBazan': magdaBazan,
                    'malgorzataStarczewska': malgorzataStarczewska,
                    'mateuszMaternia': mateuszMaternia
                },
                'psychology': {
                    'magdalenaWaszak': magdalenaWaszak,
                    'joannaMaciejewska': joannaMaciejewska,
                    'anetaStawiszynskaBiarda': anetaStawiszynskaBiarda,
                    'zofiaKurowska': zofiaKurowska,
                    // 'martynaMarzec': martynaMarzec,
                },
                'sexuology': {
                    'martaMalecka': martaMalecka
                }
            }
        }
    });

    return function stop() {};
});